import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function RegionalAgents() {
  const [agents, setAgents] = useState([])
  const [stats, setStats] = useState(null)
  const [pendingWithdrawals, setPendingWithdrawals] = useState([])
  const [activeTab, setActiveTab] = useState('agents')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setLoading(true)
    try {
      const [agentsRes, statsRes] = await Promise.all([
        fetch(`${API}/regional-agents`),
        fetch(`${API}/regional-agents/stats/summary`)
      ])
      
      const agentsData = await agentsRes.json()
      const statsData = await statsRes.json()
      
      if (agentsData.success) setAgents(agentsData.data)
      if (statsData.success) setStats(statsData.data)
      // 提现列表暂时不加载，等后端有接口再启用
      setPendingWithdrawals([])
    } catch (e) {
      console.error('获取数据失败', e)
    }
    setLoading(false)
  }

  const handleApproveWithdrawal = async (id, approved) => {
    if (!confirm(approved ? '确认批准此提现申请？' : '确认拒绝此提现申请？')) return
    
    try {
      const res = await fetch(`${API}/regional-agents/withdraw/${id}/approve`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ approved })
      })
      const d = await res.json()
      if (d.success) {
        alert(d.message)
        fetchData()
      } else {
        alert(d.error)
      }
    } catch (e) {
      alert('操作失败')
    }
  }

  const handleActivateAgent = async (agentId) => {
    if (!confirm('确认开通此代理？将生成代理费收入记录。')) return
    
    try {
      const res = await fetch(`${API}/regional-agents/${agentId}/activate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ paymentMethod: 'bank_transfer' })
      })
      const d = await res.json()
      if (d.success) {
        alert('代理已开通！')
        fetchData()
      } else {
        alert(d.error)
      }
    } catch (e) {
      alert('操作失败')
    }
  }

  const getLevelName = (level) => {
    const names = { province: '省级代理', city: '市级代理', county: '县级代理' }
    return names[level] || level
  }

  const getStatusColor = (status) => {
    const colors = { active: '#52c41a', pending: '#faad14', expired: '#ff4d4f', suspended: '#999' }
    return colors[status] || '#999'
  }

  if (loading) {
    return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontSize: 20, margin: 0 }}>🗺️ 区域代理管理</h2>
        <div style={{ display: 'flex', gap: 12 }}>
          <button 
            onClick={() => window.open('/cms/?page=regional-agent-register', '_blank')}
            style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}
          >
            📝 新增代理申请
          </button>
          <button onClick={fetchData} style={{ padding: '10px 20px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
            🔄 刷新数据
          </button>
        </div>
      </div>

      {/* 统计卡片 */}
      {stats && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 16, marginBottom: 24 }}>
          <div style={{ background: '#fff', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ color: '#666', fontSize: 13, marginBottom: 4 }}>代理总数</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#1890ff' }}>{stats.total_agents || 0}</div>
            <div style={{ fontSize: 11, color: '#52c41a', marginTop: 4 }}>已开通 {stats.active_count || 0}</div>
          </div>
          <div style={{ background: '#fff', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ color: '#666', fontSize: 13, marginBottom: 4 }}>代理费收入</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#722ed1' }}>¥{(stats.total_agent_fee || 0).toLocaleString()}</div>
          </div>
          <div style={{ background: '#fff', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ color: '#666', fontSize: 13, marginBottom: 4 }}>团队销售额</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#fa8c16' }}>¥{(stats.total_sales || 0).toLocaleString()}</div>
          </div>
          <div style={{ background: '#fff', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ color: '#666', fontSize: 13, marginBottom: 4 }}>佣金支出</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#ff4d4f' }}>¥{(stats.total_commission || 0).toLocaleString()}</div>
          </div>
          <div style={{ background: '#fff', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ color: '#666', fontSize: 13, marginBottom: 4 }}>待审批提现</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#faad14' }}>¥{(stats.pending_withdrawal || 0).toLocaleString()}</div>
          </div>
        </div>
      )}

      {/* Tab切换 */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 16, background: '#f5f5f5', padding: 4, borderRadius: 8, width: 'fit-content' }}>
        <button 
          onClick={() => setActiveTab('agents')}
          style={{ padding: '8px 20px', background: activeTab === 'agents' ? '#fff' : 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: activeTab === 'agents' ? 600 : 400 }}
        >
          代理列表
        </button>
        <button 
          onClick={() => setActiveTab('pending')}
          style={{ padding: '8px 20px', background: activeTab === 'pending' ? '#fff' : 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: activeTab === 'pending' ? 600 : 400 }}
        >
          待缴费申请 {agents.filter(a => a.status === 'pending').length > 0 && <span style={{ background: '#ff4d4f', color: '#fff', padding: '2px 6px', borderRadius: 10, fontSize: 11, marginLeft: 4 }}>{agents.filter(a => a.status === 'pending').length}</span>}
        </button>
        <button 
          onClick={() => setActiveTab('withdrawals')}
          style={{ padding: '8px 20px', background: activeTab === 'withdrawals' ? '#fff' : 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: activeTab === 'withdrawals' ? 600 : 400 }}
        >
          提现审批 {pendingWithdrawals.length > 0 && <span style={{ background: '#faad14', color: '#fff', padding: '2px 6px', borderRadius: 10, fontSize: 11, marginLeft: 4 }}>{pendingWithdrawals.length}</span>}
        </button>
      </div>

      {/* 代理列表 */}
      {activeTab === 'agents' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginTop: 0, marginBottom: 16 }}>代理列表</h3>
          
          {agents.filter(a => a.status === 'active').length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
              暂无已开通的代理
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>代理ID</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>姓名</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>手机号</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>代理区域</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>级别</th>
                  <th style={{ padding: 12, textAlign: 'right', fontWeight: 600 }}>团队销售额</th>
                  <th style={{ padding: 12, textAlign: 'right', fontWeight: 600 }}>累计佣金</th>
                  <th style={{ padding: 12, textAlign: 'right', fontWeight: 600 }}>可用余额</th>
                  <th style={{ padding: 12, textAlign: 'center', fontWeight: 600 }}>状态</th>
                </tr>
              </thead>
              <tbody>
                {agents.filter(a => a.status === 'active').map(agent => (
                  <tr key={agent.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 12 }}>{agent.agent_id}</td>
                    <td style={{ padding: 12 }}>{agent.name}</td>
                    <td style={{ padding: 12 }}>{agent.phone}</td>
                    <td style={{ padding: 12 }}>{agent.region_name}</td>
                    <td style={{ padding: 12 }}>
                      <span style={{ 
                        padding: '4px 8px', 
                        borderRadius: 4, 
                        fontSize: 12,
                        background: agent.region_level === 'province' ? '#722ed120' : agent.region_level === 'city' ? '#fa8c1620' : '#13c2c220',
                        color: agent.region_level === 'province' ? '#722ed1' : agent.region_level === 'city' ? '#fa8c16' : '#13c2c2'
                      }}>
                        {getLevelName(agent.region_level)}
                      </span>
                    </td>
                    <td style={{ padding: 12, textAlign: 'right', color: '#1890ff' }}>
                      ¥{(agent.total_sales || 0).toLocaleString()}
                    </td>
                    <td style={{ padding: 12, textAlign: 'right', color: '#52c41a' }}>
                      ¥{(agent.total_commission || 0).toLocaleString()}
                    </td>
                    <td style={{ padding: 12, textAlign: 'right', fontWeight: 600 }}>
                      ¥{(agent.available_balance || 0).toLocaleString()}
                    </td>
                    <td style={{ padding: 12, textAlign: 'center' }}>
                      <span style={{ 
                        padding: '4px 8px', 
                        borderRadius: 4, 
                        fontSize: 12,
                        background: getStatusColor(agent.status) + '20',
                        color: getStatusColor(agent.status)
                      }}>
                        正常
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* 待缴费申请 */}
      {activeTab === 'pending' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginTop: 0, marginBottom: 16 }}>待缴费申请</h3>
          
          {agents.filter(a => a.status === 'pending').length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
              暂无待缴费申请
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>代理ID</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>姓名</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>手机号</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>代理区域</th>
                  <th style={{ padding: 12, textAlign: 'right', fontWeight: 600 }}>代理费</th>
                  <th style={{ padding: 12, textAlign: 'center', fontWeight: 600 }}>申请时间</th>
                  <th style={{ padding: 12, textAlign: 'center', fontWeight: 600 }}>操作</th>
                </tr>
              </thead>
              <tbody>
                {agents.filter(a => a.status === 'pending').map(agent => (
                  <tr key={agent.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 12 }}>{agent.agent_id}</td>
                    <td style={{ padding: 12 }}>{agent.name}</td>
                    <td style={{ padding: 12 }}>{agent.phone}</td>
                    <td style={{ padding: 12 }}>{agent.region_name} - {getLevelName(agent.region_level)}</td>
                    <td style={{ padding: 12, textAlign: 'right', color: '#fa8c16', fontWeight: 600 }}>
                      ¥{agent.agent_fee.toLocaleString()}
                    </td>
                    <td style={{ padding: 12, textAlign: 'center' }}>{agent.created_at}</td>
                    <td style={{ padding: 12, textAlign: 'center' }}>
                      <button 
                        onClick={() => handleActivateAgent(agent.agent_id)}
                        style={{ padding: '6px 16px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}
                      >
                        确认收款开通
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* 提现审批 */}
      {activeTab === 'withdrawals' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginTop: 0, marginBottom: 16 }}>提现审批</h3>
          
          {pendingWithdrawals.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
              暂无待审批提现
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>代理</th>
                  <th style={{ padding: 12, textAlign: 'right', fontWeight: 600 }}>提现金额</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>银行</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>账号</th>
                  <th style={{ padding: 12, textAlign: 'left', fontWeight: 600 }}>户名</th>
                  <th style={{ padding: 12, textAlign: 'center', fontWeight: 600 }}>申请时间</th>
                  <th style={{ padding: 12, textAlign: 'center', fontWeight: 600 }}>操作</th>
                </tr>
              </thead>
              <tbody>
                {pendingWithdrawals.map(w => (
                  <tr key={w.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 12 }}>
                      <div>{w.agent_name}</div>
                      <div style={{ fontSize: 11, color: '#999' }}>{w.region_name} - {w.region_level === 'province' ? '省级' : w.region_level === 'city' ? '市级' : '县级'}代理</div>
                    </td>
                    <td style={{ padding: 12, textAlign: 'right', color: '#ff4d4f', fontWeight: 600, fontSize: 16 }}>
                      ¥{w.amount.toLocaleString()}
                    </td>
                    <td style={{ padding: 12 }}>{w.bank_name}</td>
                    <td style={{ padding: 12 }}>{w.bank_account}</td>
                    <td style={{ padding: 12 }}>{w.account_name}</td>
                    <td style={{ padding: 12, textAlign: 'center' }}>{w.created_at}</td>
                    <td style={{ padding: 12, textAlign: 'center' }}>
                      <button 
                        onClick={() => handleApproveWithdrawal(w.id, true)}
                        style={{ padding: '6px 12px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 8 }}
                      >
                        批准
                      </button>
                      <button 
                        onClick={() => handleApproveWithdrawal(w.id, false)}
                        style={{ padding: '6px 12px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}
                      >
                        拒绝
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* 商业化配置说明 */}
      <div style={{ marginTop: 24, background: '#e6f7ff', borderRadius: 8, padding: 20 }}>
        <h4 style={{ marginTop: 0, color: '#1890ff' }}>💡 区域代理政策</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, fontSize: 14 }}>
          <div>
            <div style={{ fontWeight: 600, color: '#722ed1', marginBottom: 4 }}>省级代理</div>
            <div>代理费：¥50,000</div>
            <div>推荐奖：一级40%+二级10%</div>
            <div>管理奖：10%</div>
          </div>
          <div>
            <div style={{ fontWeight: 600, color: '#fa8c16', marginBottom: 4 }}>市级代理</div>
            <div>代理费：¥20,000</div>
            <div>推荐奖：一级30%+二级10%</div>
            <div>管理奖：8%</div>
          </div>
          <div>
            <div style={{ fontWeight: 600, color: '#13c2c2', marginBottom: 4 }}>县级代理</div>
            <div>代理费：¥5,000</div>
            <div>推荐奖：一级20%</div>
            <div>管理奖：5%</div>
          </div>
        </div>
      </div>
    </div>
  )
}
